module.exports = __webpack_public_path__ + "img/get-driving-in-48-hours.c2c126e2.jpg";